import type { Family } from './family.type.ts';
export interface FamilyExtension extends Family {}
export class FamilyExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get fullName() {
    return [this.firstName, this.lastName].join(' ');
  }
}

const Registration = {
  kind: 'object',
  name: 'family',
  features: FamilyExtension,
};
export default Registration;
